(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["october-warmth"] && !Shopify.designMode) return;
  try {
    function initializeCozyDots(scope) {
  scope.querySelectorAll('.gd-october').forEach(function(root) {
    const row = root.querySelector('.gd-october__grid');
    const dots = root.querySelector('[data-cozy-dots]');
    if (!row || !dots || root.dataset.cozyDotsReady) return;
    root.dataset.cozyDotsReady = 'true';
    let positions = [];
    function update() {
      let nearest = 0;
      positions.forEach(function(position, index) {
        if (Math.abs(position - row.scrollLeft) < Math.abs(positions[nearest] - row.scrollLeft)) nearest = index;
      });
      dots.querySelectorAll('button').forEach(function(button, index) {
        button.setAttribute('aria-current', index === nearest ? 'true' : 'false');
      });
    }
    function rebuild() {
      const max = Math.max(0, row.scrollWidth - row.clientWidth);
      const pages = max > 2 ? Math.ceil(max / Math.max(1, row.clientWidth * 0.8)) + 1 : 1;
      positions = Array.from({length: pages}, function(_, index) { return pages === 1 ? 0 : max * index / (pages - 1); });
      dots.replaceChildren();
      dots.hidden = pages === 1;
      positions.forEach(function(position, index) {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', 'View fragrance group ' + (index + 1));
        button.setAttribute('aria-controls', row.id);
        button.addEventListener('click', function() {
          row.scrollTo({left: position, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        });
        dots.appendChild(button);
      });
      update();
    }
    row.addEventListener('scroll', update, {passive: true});
    new ResizeObserver(rebuild).observe(row);
    rebuild();
  });
}
initializeCozyDots(document);
document.addEventListener('shopify:section:load', function(event) { initializeCozyDots(event.target); });
  } catch(e) { console.error(e); }
})();

})();
